declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_structural_quoted_props_foo extends $mol_object {
		bar( ): ({ 
			'a$': number,
			'b-t': Record<string, any>,
		}) 
	}
	
}

//# sourceMappingURL=structural_quoted_props.view.tree.d.ts.map